module.exports = __webpack_public_path__ + "static/4-Kas-gali-dalyvauti-31412402c83f583665940293451c3cdd.svg";